import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import PartnersApi from '@/api/partners'
import { HttpStatus } from '@/constants/httpStatus'

@Module({ namespaced: true })
export default class PartnersModule extends VuexModule {
    public filters: PartnerFiltersEntity = {
        nameOrCnpj: '',
        category: '',
        status: '',
        apikeyStatus: '',
    }
    public isLoading: boolean = false
    public partners: PartnerEntity[] = []
    public categories: PartnerCategoryEntity[] = []

    @Mutation
    public setFilters(filters: PartnerFiltersEntity) {
        this.filters = filters
    }

    @Mutation
    public setLoading(loading: boolean) {
        this.isLoading = loading
    }

    @Mutation
    public setPartners(partners: PartnerEntity[]) {
        this.partners = partners
    }

    @Mutation
    public setCategories(categories: PartnerCategoryEntity[]) {
        this.categories = categories
    }

    @Action
    public filterPartners(filters: PartnerFiltersEntity) {
        this.context.commit('setFilters', filters)
        this.context.dispatch('fetchPartners')
    }

    @Action
    public async fetchPartners(): Promise<boolean> {
        if (this.isLoading) {
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', true)

        const params = {
            nameOrCnpj: this.filters.nameOrCnpj.trim(),
            category: this.filters.category,
            status: this.filters.status,
            apikeyStatus: this.filters.apikeyStatus,
        }

        const response = await PartnersApi.viewPartners(params)

        if (response.status === HttpStatus.CANCELLED) {
            return Promise.resolve(false)
        }

        if (response.status === HttpStatus.SUCCESS) {
            this.context.commit('setPartners', response.data!.partners)
            this.context.commit('setCategories', response.data!.categories)
        } else {
            alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', false)
        return Promise.resolve(true)
    }
}
